import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const RegressionTestingStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({
    stepRun,
}) => {
    return <div>Regression Testing Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
